'use strict';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {
  assignOrganizationToModel,
  organizationDeleted,
  projectDeleted,
  assetDeleted,
  removeFromLastAccessedOrganizations,
  removeFromLastAccessedProjects,
  removeFromLastAccessedAssets,
} from '../actions';
import {logger} from './logger';

export const epics = [
  onDeleteOrganization,
  onDeleteProject,
  onDeleteAsset,
];

export function onDeleteOrganization(action$) {
  return buildOnDelete(action$, 'onDeleteOrganization', organizationDeleted.TYPE, removeFromLastAccessedOrganizations);
}

export function onDeleteProject(action$) {
  return buildOnDelete(action$, 'onDeleteProject', projectDeleted.TYPE, removeFromLastAccessedProjects);
}

export function onDeleteAsset(action$) {
  return buildOnDelete(action$, 'onDeleteAsset', assetDeleted.TYPE, removeFromLastAccessedAssets);
}


/**
 *
 * @param {String} name Name of the function, for logging purposes
 * @param {String} type Action type for the assignment to watch
 * @param {Function} removalAction Action creator for the actions to dispatch
 * @param {ActionsObservable<ReduxAction>} action$
 * @return {Observable<ReduxAction>}
 */
function buildOnDelete(action$, name, type, removalAction) {
  return action$.ofType(assignOrganizationToModel.TYPE)
    .map(action => getId(action.payload.organization))
    .filter(id => !!id)
    .switchMap(orgId =>
      action$.ofType(type)
        .map(action => removalAction(orgId, action.payload.id))
    )
    .catch(epicErrorHandler(logger, name));
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/onDeletion.js